var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.949422, 0, 0, 0.945996, -33.33699, -164.534195)",
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.7,526.5L177.7,526.5c-3.5-3.4-3.6-9,0-12.4c11.2-10.7,23.7-19.8,37.3-27.1c16.6-9,34.4-15.2,53-18.4l2.9,16.9 c-16.8,2.9-32.8,8.5-47.8,16.6c-12.3,6.6-23.6,14.9-33.7,24.5C186.1,529.6,181,529.6,177.7,526.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.949422, 0, 0, 0.945996, -33.33699, -164.534195)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.9,525.9c-22.4-21.1-50-35-80.4-40.4l3-16.9c18.3,3.2,35.9,9.4,52.3,18.2c13.4,7.2,25.8,16.2,36.8,26.6 c3.6,3.3,3.5,9,0,12.4l0,0C414.4,529,409.2,529,405.9,525.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.949422, 0, 0, 0.945996, -33.33699, -164.534195)",
    style: {}
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.8,458.7L109.8,458.7c-3.5-3.4-3.5-8.9,0-12.3c19.3-18.7,41.2-34.4,65.1-46.7c27.2-13.9,56.4-23.1,86.8-27.1l0.3,17.2 c-28.4,3.8-53.8,12.1-79.3,25.1c-22.4,11.5-42.9,26.1-61,43.7C118.4,461.9,113.1,461.9,109.8,458.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.949422, 0, 0, 0.945996, -33.33699, -164.534195)",
    style: {}
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M485.5,457.9c-3.3,3.2-8.6,3.2-11.9,0c-17.9-17.2-38-31.6-60-42.9c-25.1-12.9-49.8-21.1-77.8-25l0.3-17.3 c29.8,4.2,58.5,13.3,85.3,27c23.5,12.1,45.1,27.5,64.1,45.8C488.9,449,488.9,454.6,485.5,457.9L485.5,457.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.949422, 0, 0, 0.945996, -33.33699, -164.534195)",
    style: {}
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2,392.5L42.2,392.5c-3.4-3.3-3.5-8.9,0-12.2c28.1-27.6,60.3-50.4,95.6-67.7c39.1-19.1,80.9-31,124.2-35.2l0,15.3 c-41.3,4-79.5,17-116.7,35.2c-33.7,16.5-64.3,38.2-91.2,64.5C50.8,395.7,45.5,395.7,42.2,392.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.949422, 0, 0, 0.945996, -33.33699, -164.534195)",
    style: {}
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M551.9,390.5c-3.3,3.3-8.6,3.3-11.9,0.1c-26.5-25.6-56.6-46.8-89.7-62.9c-36.6-17.8-73.9-28.8-114.5-32.9l0-17.2 c42.5,4.4,83.6,16.1,121.9,34.8c34.7,16.9,66.3,39.1,94.1,66C555.3,381.6,555.3,387.1,551.9,390.5L551.9,390.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 119.264595, -216.958588)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.1,378.7",
    style: {
      fill: "none",
      stroke: "rgb(0, 0, 0)",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 246.913,
    cy: 448.262,
    r: 56.2,
    style: {},
    transform: "matrix(0.949422, 0, 0, 0.945996, 14.122052, 11.456594)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.949422, 0, 0, 0.945996, -33.33699, -164.534195)",
    style: {}
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M311.1,181.2h-24.8c-4.5,0-8.1,3.6-8.1,8.1v190.3l8.7,127.1c0.4,5.8,5.2,10.3,11,10.3c5.7,0,10.5-4.4,11-10.1l10.3-127.2 V189.3C319.2,184.9,315.6,181.2,311.1,181.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnected);
export default __webpack_public_path__ + "static/media/no_connected.e6d38b19a427fd940eec4d7671043a57.svg";
export { ForwardRef as ReactComponent };